<template>
  <div class="communications">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Communications',
};
</script>
